














import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ContractItem from '@/domain/contract/entity/contract-item.entity';

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class ExchangeConfigurationButton extends Vue {
  @Prop() contractItem!: ContractItem;

  @Prop() disabled!: boolean;

  @Emit('click')
  private click(): void {}

  get tooltipText() {
    return this.contractItem.hasCurrencyExchange
      ? 'Configuração de conversão - Configuração Ativa'
      : 'Configuração de conversão - Configuração Inativa'
  }
}
